import { getEffectiveFirebaseIdToken } from '@/features/impersonation/effectiveFirebaseToken'
import { ChatCallPermission } from '@/models/chat.model'
import { api } from '@/services/api'
import { MetaCallPermission } from './voiceApi'

export async function markCallPermissionInvitation(chatId: string, ownerId: string) {
  const token = await getEffectiveFirebaseIdToken()
  const response = await api.post<{ callPermission: ChatCallPermission }>(
    `/mongo/chats/${encodeURIComponent(chatId)}/call-permission-invitation`,
    { ownerId },
    { headers: { Authorization: `Bearer ${token}` } }
  )
  return response.data.callPermission
}

export async function syncCallPermissionLookup(chatId: string, ownerId: string, permission: MetaCallPermission) {
  const token = await getEffectiveFirebaseIdToken()
  const response = await api.post<{ callPermission: ChatCallPermission }>(
    `/mongo/chats/${encodeURIComponent(chatId)}/call-permission-sync`,
    { ownerId, permission },
    { headers: { Authorization: `Bearer ${token}` } }
  )
  return response.data.callPermission
}
